<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  comparison: {
    type: Object,
    required: true,
  },
  showIndustry: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const store = useStore();

const links = computed(() => store.state.generic.links);
const industries = computed(() => store.state.generic.industries);

const components = computed(() => {
  if (props.product) {
    return props.comparison.components
      .filter((component) => component.uid !== props.product.uid);
  }

  return props.comparison.components;
});

const comparisonIndustry = computed(() => (
  industries.value?.find((i) => i.code === props.comparison.industry)
));
</script>

<template>
  <tr>
    <td>
      {{ comparison.title }}
    </td>
    <td v-if="showIndustry">
      {{ comparisonIndustry?.title ?? comparison.industry }}
    </td>
    <td>
      <ul class="list-reset">
        <li
          v-for="component in components"
          :key="`${comparison.id}_${component.uid}`">
          <a
            :href="`${component.link}?i=${comparison.industry}`"
            target="_blank">
            {{ component.productName }}
          </a>
        </li>
      </ul>
    </td>
    <td class="actionCell">
      <div class="actionsWrapper">
        <tooltip
          class="tooltipTrigger"
          v-if="comparison.content"
          :content="comparison.content"
          trigger="click"
          :delay="0">
          <fa-icon
            class="cursor-pointer"
            icon="exclamation-circle" />
        </tooltip>
        <a :href="`${links.advancedComparePage}${comparison.id}`">
          <fa-icon icon="right-left" />
        </a>
      </div>
    </td>
  </tr>
</template>

<style lang="less" scoped>
@import (reference) "~styles/includes/base";

tr td {
  padding: @space-2;
  line-height: 1.5;

  &.actionCell {
    .actionsWrapper {
      .ms(-1);
      display: flex;
      gap: @space-2;

      a, .tooltipTrigger {
        color: @color-mono-60;
        transition: color .25s ease-in-out;

        &:hover {
          color: @color-light;
        }
      }
    }
  }
}

ul {
  display: flex;
  flex-wrap: wrap;
  gap: @space-2;
  margin: 0;

  li {
    a {
      display: block;
      padding: @space-1 @space-2;
      border-radius: @border-radius;
      background: @color-mono-50;
      color: @color-mono-100;
      .ms(-3);
      position: relative;
      font-weight: 600;
      transition: background-color 250ms ease-in-out;

      &:hover {
        background: @color-light;
      }
    }
  }
}

.action {
  a {
    color: @color-mono-60;
    transition: color 250ms ease-in-out;

    &:hover {
      color: @color-light;
    }
  }
}
</style>
